export const notificationConstants = {
    GET_NOTIFICATIONS: "GET_NOTIFICATIONS",
    DELETE_NOTIFICATIONS: "DELETE_NOTIFICATIONS",
    LOADING: "LOADING",
    RESPONSE_STATE: "RESPONSE_STATE"
}